import { CoreMenu } from '@core/types';
import { TipoSistemaKey } from 'app/interfaces/enum/tipo-sistema';

const MENU_TIPO_SISTEMA_CONFIG: Record<string, TipoSistemaKey[]> = {
  oportunidade: ['AGENCIAMENTO_CARGA'],
  oportunidade_tr: ['TRANSPORTE_RODOVIARIO'],
  incoterm: ['AGENCIAMENTO_CARGA'],
  marcas_de_veiculos: ['TRANSPORTE_RODOVIARIO'],
  modelos_de_veiculos: ['TRANSPORTE_RODOVIARIO'],
  carrocerias_de_veiculos: ['TRANSPORTE_RODOVIARIO'],
  veiculo: ['TRANSPORTE_RODOVIARIO'],
  composicao_veicular: ['TRANSPORTE_RODOVIARIO'],
  processo_tr: ['TRANSPORTE_RODOVIARIO'],
  processo: ['AGENCIAMENTO_CARGA'],
  tabela_frete: ['TRANSPORTE_RODOVIARIO'],
  fatura_tr: ['TRANSPORTE_RODOVIARIO'],
  faturas: ['AGENCIAMENTO_CARGA'],
  extrato_bancario: ['AGENCIAMENTO_CARGA'],
  cfop: ['TRANSPORTE_RODOVIARIO'],
  cst: ['TRANSPORTE_RODOVIARIO'],
  gestao_risco: ['TRANSPORTE_RODOVIARIO'],
  tarifario: ['AGENCIAMENTO_CARGA'],
  tipo_container: ['AGENCIAMENTO_CARGA'],
  tarifario_local: ['AGENCIAMENTO_CARGA'],
  tarifario_demurrage: ['AGENCIAMENTO_CARGA'],
  controle_booking: ['AGENCIAMENTO_CARGA'],
  network: ['AGENCIAMENTO_CARGA'],
  devolucao_de_container: ['AGENCIAMENTO_CARGA'],
  tabela_piso_minimo_frete: ['TRANSPORTE_RODOVIARIO'],
  inventario: ['AGENCIAMENTO_CARGA'],
  budget: ['AGENCIAMENTO_CARGA'],
  categorias_financeiras: ['AGENCIAMENTO_CARGA'],
  centro_de_custo: ['AGENCIAMENTO_CARGA'],
  conta_contabil: ['AGENCIAMENTO_CARGA'],
  despesa: ['AGENCIAMENTO_CARGA'],
  farol_de_metas: ['AGENCIAMENTO_CARGA'],
  cargo: ['AGENCIAMENTO_CARGA'],
  departamento: ['AGENCIAMENTO_CARGA'],
  metas: ['AGENCIAMENTO_CARGA'],
};

export function filterMenuByTipoSistema(menu: CoreMenu[], tipoSistema: TipoSistemaKey | TipoSistemaKey[] | null): CoreMenu[] {
  const tipoSistemaKeys = normalizaTipoSistema(tipoSistema);

  return filterMenuItems(menu, tipoSistemaKeys);
}

function normalizaTipoSistema(tipoSistema: TipoSistemaKey | TipoSistemaKey[] | null): TipoSistemaKey[] {
  if (!tipoSistema) {
    return [];
  }

  return Array.isArray(tipoSistema) ? tipoSistema : [tipoSistema];
}

function filterMenuItems(menu: CoreMenu[], tipoSistemaKeys: TipoSistemaKey[]): CoreMenu[] {
  return menu
    .map(menuItem => {
      if (shouldHideMenuItem(menuItem.id, tipoSistemaKeys)) {
        return null;
      }

      if (menuItem.children && menuItem.children.length > 0) {
        const filteredChildren = filterMenuItems(menuItem.children as CoreMenu[], tipoSistemaKeys);

        if (filteredChildren.length === 0) {
          return null;
        }

        return {
          ...menuItem,
          children: filteredChildren,
        };
      }

      return menuItem;
    })
    .filter((item): item is CoreMenu => item !== null);
}

function shouldHideMenuItem(menuItemId: string, tipoSistemaKeys: TipoSistemaKey[]): boolean {
  const tiposPermitidos = MENU_TIPO_SISTEMA_CONFIG[menuItemId];

  if (!tiposPermitidos) {
    return false;
  }

  if (!tipoSistemaKeys.length) {
    return true;
  }

  return !tiposPermitidos.some(tipoPermitido => tipoSistemaKeys.includes(tipoPermitido));
}
